(() => {
  const nav = document.querySelector('.wr-home-navbar');
  if (!nav) return;

  const links = Array.from(nav.querySelectorAll('.wr-home-navbar__link[data-wr-anchor]'));
  const sections = Array.from(document.querySelectorAll('.wr-featured-collection[data-wr-anchor]'));
  if (!links.length || !sections.length) return;

  const linkByAnchor = new Map(links.map((link) => [link.dataset.wrAnchor, link]));
  const sectionByAnchor = new Map(sections.map((section) => [section.dataset.wrAnchor, section]));
  const visibility = new Map();
  let observer;
  let resizeTimer;

  const getHeaderOffset = () => {
    const headerHeight = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height')
    );
    return (Number.isFinite(headerHeight) ? headerHeight : 0) + 24;
  };

  const setActive = (anchor) => {
    links.forEach((link) => {
      link.classList.toggle('is-active', link.dataset.wrAnchor === anchor);
    });
  };

  const handleIntersect = (entries) => {
    entries.forEach((entry) => visibility.set(entry.target, entry));
    const visible = Array.from(visibility.values()).filter((entry) => entry.isIntersecting);
    if (!visible.length) return;
    visible.sort((a, b) => b.intersectionRatio - a.intersectionRatio);
    const anchor = visible[0].target.dataset.wrAnchor;
    if (anchor) setActive(anchor);
  };

  const createObserver = () => {
    if (observer) observer.disconnect();
    const topOffset = getHeaderOffset();
    observer = new IntersectionObserver(handleIntersect, {
      rootMargin: `-${topOffset}px 0px -50% 0px`,
      threshold: [0, 0.25, 0.5, 0.75, 1],
    });
    sections.forEach((section) => observer.observe(section));
  };

  const scrollToSection = (anchor) => {
    const target = sectionByAnchor.get(anchor);
    if (!target) return;
    const top = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
    window.history.pushState(null, '', `#${anchor}`);
    window.scrollTo({ top, behavior: 'smooth' });
  };

  links.forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      scrollToSection(link.dataset.wrAnchor);
    });
  });

  const initialHash = decodeURIComponent(window.location.hash || '');
  if (initialHash.startsWith('#')) {
    const anchor = initialHash.replace('#', '');
    if (sectionByAnchor.has(anchor)) {
      setTimeout(() => scrollToSection(anchor), 0);
    }
  }

  createObserver();
  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(createObserver, 200);
  });
})();
